import { orderBy, get } from 'lodash';
import { convertToDisplayValue } from './strings';

const sortByProperty = (arr, prop) => arr.sort((a, b) => (
    (a[prop] > b[prop]) ? 1 : ((b[prop] > a[prop]) ? -1 : 0) // eslint-disable-line no-nested-ternary
));

const groupByKey = (aoo, key) => aoo.reduce((rv, o) => {
    (rv[o[key]] = rv[o[key]] || []).push(o);
    return rv;
}, {});

const shouldShowTotalActivities = (state) => {
    const shouldShowTotalActivties = get(state, 'entities.meta.meta.showTotalActivities', false);
    const entityObjective = get(state, 'entities.meta.meta.programmaticObjective.global', 'ecpa');
    if (entityObjective !== 'ctr') {
        return shouldShowTotalActivties;
    }
    return false;
};

const sortByTwoProperties = (arr, first, second) => {
    const chunks = groupByKey(arr, first);
    const sortedChunks = [];
    Object.keys(chunks).sort().forEach((year) => {
        sortedChunks.push(sortByProperty(chunks[year], second));
    });
    return sortedChunks.reduce((acc, cur) => acc.concat(cur), []);
};

const reduceCreativesData = (creatives, { filterField, removeJobNumber = false } = {}) =>
    // removeJobNumber removes job numbers from labels in the format of IPXXXXXXX
    Object.entries(creatives.creativeMap).reduce((prev, creative) => {
        const label = creative[0];
        const sizes = creative[1];
        const formattedLabel = removeJobNumber ? label.replace(/(IP|G)[\d]{5,7}[\s_-]*/g, '') : label;
        if (filterField) {
            if (creatives[label].aggregate.statistics[filterField] > 0) {
                prev.byLabel.push(Object.assign({
                    creativeLabel: formattedLabel
                }, creatives[label].aggregate.statistics));
            }
        } else {
            prev.byLabel.push(Object.assign({
                creativeLabel: formattedLabel
            }, creatives[label].aggregate.statistics));
        }

        prev.bySize.push(...sizes.reduce((acc, size) => {
            if (filterField) {
                if (creatives[label][size].statistics[filterField] > 0) {
                    acc.push(Object.assign({
                        creativeLabel: formattedLabel,
                        creativeSize: size
                    }, creatives[label][size].statistics));
                }
            } else {
                acc.push(Object.assign({
                    creativeLabel: formattedLabel,
                    creativeSize: size
                }, creatives[label][size].statistics));
            }

            return acc;
        }, []));

        return prev;
    }, { bySize: [], byLabel: [] });


const reduceNameBasedData = ({ data, namesArrayKey, injectedKey, sortBy = 'ecpa_activities' } = {}) => {
    const reducedData = { graph: {}, table: [], sortedKeys: [] };
    const scopeKey = data.categories.config.selector;

    data[namesArrayKey].forEach((name) => {
        // Must have delivery to include name
        if (data[name].statistics.impressions > 0
            || data[name].statistics.ecpa_activities > 0
            || data[name].statistics.total_activities > 0) {
            reducedData.sortedKeys.push(name);
            reducedData.graph[name] = data[name][scopeKey];
            reducedData.table.push({
                [injectedKey]: name,
                ...data[name].statistics
            });
        }
    });
    reducedData.categories = data.categories[scopeKey];
    reducedData.sortedKeys.sort((a, b) =>
        data[b].statistics[sortBy] - data[a].statistics[sortBy]);

    return reducedData;
};

const reduceLayerTwoData = (layer) => {
    const childSummaryTableData = Object.keys(layer.data.entities).map(name => ({
        entity_name: name,
        entity_id: layer.data.entities[name],
        ...layer.data.summary[name]
    }));
    const childSeriesData = Object.keys(layer.data.data).reduce((prev, name) => {
        prev[name] = layer.data.data[name][layer.data.categories.config.selector];

        return prev;
    }, {});

    return { childSummaryTableData, childSeriesData };
};

const backfill = (data, timestamps) => {
    if (timestamps.length > 0) {
        const inDates = data.map(r => r.x);
        const difference = timestamps.filter(d => !inDates.includes(d));
        difference.reduce((prev, ts) => {
            prev.push({ x: ts, y: 0 });
            return prev;
        }, data);
    }
    return orderBy(data, ['x']);
};

const getTopN = (intermediateSeries, topNData, showTopN) => {
    // sort topNData and select top n based on showTopN value
    const sortable = Object.keys(topNData).reduce((prev, key) => {
        prev.push([key, topNData[key]]);
        return prev;
    }, []).sort((a, b) => b[1] - a[1]);
    const topNArray = sortable.slice(0, showTopN);
    const topNEntries = topNArray.reduce((prev, curr) => {
        prev[convertToDisplayValue(curr[0])] = curr[1];
        return prev;
    }, {});
    const dataTotals = intermediateSeries[0].data.reduce((prev, curr) => {
        prev[curr.x] = 0;
        return prev;
    }, {});
    // sum data for each timestamp and construct total line graph data

    intermediateSeries.forEach((obj) => {
        obj.data.forEach((dataPoint) => {
            dataTotals[dataPoint.x] += dataPoint.y;
        });
    });
    const dataTotalsTS = Object.keys(dataTotals).map(key => ({ x: parseInt(key, 10), y: dataTotals[key] }));
    // filter data for only top n
    const series = intermediateSeries.filter(obj => obj.name in topNEntries);
    series.push({
        name: 'Total across all campaigns',
        color: '#A0A0A0',
        data: dataTotalsTS,
        type: 'line'
    });
    return series;
};

export default {
    reduceCreativesData,
    reduceLayerTwoData,
    reduceNameBasedData,
    sortByProperty,
    sortByTwoProperties,
    backfill,
    getTopN,
    shouldShowTotalActivities
};



// WEBPACK FOOTER //
// ./src/helpers/data.js